export const config = {
  AEM_DAM_URL: "content/dam/thaiairways/",
  AIRPORT_LIST: "common/airport/list",
  CMS_BANNER_CAROUSEL_HOME: "/homepage/json/bannercarousel/jcr:content/root/container/container/bannercarousel.model.json",
  CMS_BANNER_CORPORATEANDAGENCY_CAROUSEL_HOME: "/homepage/json/corporateandagency/bannercarousel/jcr:content/root/container/container/bannercarousel.model.json",
  // ROP_URL: "osci/json/rop.json",
  COUNTRY_LIST: "common/country/getAllRegionList",
  BOARDING_PASS: "/checkin/boardingPass",
  ADDTO_GOOGLE_WALLET: "/checkin/wallet/google/add-boarding-pass",
  ADDTO_IPHONE_WALLET: "/checkin/generatePass",
  CHECKIN_BOARDING_PASS: "/check-in/boarding-passes",
  CHECKIN_BOARDING_PASS_GOOGLE_WALLET: "/check-in/boarding-passes/google-wallet",
  CHECKIN_BOARDING_PASS_APPLE_WALLET: "/check-in/boarding-passes/apple-wallet",
  GEOLOCATION: "common/geolocation",
  // TEAMSITE_ROH_LIST: "./json/roh.json",
  BOOKING_API: "refx/booking",
  MULTI_API: "multi/booking",
  ROP: "/osci/json/ropData.json",
  PROMO_API: "validatePromoCode",
  MANAGE_BOOKING_API: "managebooking",
  CHECKIN_API: "checkin",
  FLIGHTSTATUS_API: "flightstatus",
  UNLOCK_ACCOUNT_API: "profile/user/resetPinSubmit",
  TEAMSITE_PRIVILEGE_LIST: "/homepage/json/privilege/jcr:content/root/responsivegrid/privilege.model.json",
  TEAMSITE_HEADER_ENDPOINT: "/headerDetails.json",
  CMS_HEADER_ENDPOINT: "/modal/header.json",
  CMS_GOVN_HEADER_ENDPOINT: "/modal/governmentHeader.json",
  //TEAMSITE_FOOTER_ENDPOINT: "/footer.json",
  CMS_FOOTER_ENDPOINT: "/homepage/json/footer/jcr:content/root/container/footer.model.json",
  // REACT_APP_TG_UAT_URL : 'http://13.215.223.124:8080/'
  CMS_ROPMEMBERJOIN_API: "/joinnow.json",
  CMS_SAWASDEECARD_ENDPOINT: "/sawasdee.json",
  CMS_LIFESTYLE_DESTINATION_CONTENT_API: "/homepage/json/lifestyle/jcr:content/root/container/container/lifestyle.model.json",
  CMS_PARTNERS_API: "/homepage/json/partner/jcr:content/root/container/container/partners.model.json",
  TEAMSITE_APPSTORE_API: "/appStore.json",
  CMS_APPSTORE_API: "/content/dam/thaiairways/json/en-th/appStore.json",
  CMS_NOTICE_BANNER_URL: "/banner/notification.json",
  CMS_MODAL_URL: "/modal/notification.json",
  CMS_MORE_SERVICES_API: "/homepage/json/moreservices/jcr:content/root/container/container/moreservices.model.json",
  TEAMSITE_GLOBAL_SEARCH_API: "osci/json/globalSearch.json",
  TEAMSITE_GLOBAL_SEARCH_API1: "/homepage/json/globalsearch/jcr:content/root/responsivegrid/globalsearch.model.json",
  CORPORATE_HEADER: "/corporateheader.json",
  AGENCY_HEADER: "/agencyheader.json",
  TEAMSITE_SEARCH: "/content/search",
  CMS_PROMOTION: "/homepage/json/promotion/jcr:content/root/container/container/promotion.model.json",
  CMS_PROMOTION_PARTNERS_API: "/jcr:content/root/responsivegrid/offers.model.json",
  // TEAMSITE_ADDITIONAL_SERVICES_API: "./additionalServices.json",
  TEAMSITE_UPCOMING_TRIPS_API: "/trip/retrieve-trips?category=upcoming",
  TEAMSITE_RETRIEVE_PNR_API: "/trip/retrieve-pnr?isUpcoming=true",
  //TEAMSITE_NOMINEE_TERMS: "/nomineeTerms.json",
  CMS_NOMINEE_TERMS: "/homepage/json/nomineeterms/jcr:content/root/responsivegrid/nomineeterms.model.json",
  REACT_APP_AMADEUS_URL: "pss_router/",
  CRM_TEAMSITE_DELETE_ACCOUNT_TERMS: "/homepage/json/deleteaccountterms/jcr:content/root/responsivegrid/deleteaccount.model.json",
  CRM_TEAMSITE_EXTRA_BAGGAGE_DETAILS: "/homepage/json/extrabaggagedetails/jcr:content/root/responsivegrid/extrabaggagedetails.model.json",
  CRM_TEAMSITE_SEAT_PREFERENCE_DETAILS: "/homepage/json/preferredseatdetails/jcr:content/root/responsivegrid/preferredseatdetails.model.json",
  FETCH_PROFILE: "profile/fetchProfile",
  FLIGHT_INFO_API: "/airaward-flights/get-flight-info",
  FETCH_NIOMINEE: "/loyalty/nominee",
  // TEAMSITE_INSPIRATION_DEALS_DISCOVER_API: "/inspirationDeals.json",
  TEAMSITE_INSPIRATION_DEALS_DISCOVER_CONTENT_API: "./inspirationDealsCarousel.json",
  AIRPORT_MAIN_URL: "/common/airport",
  CITY_PAIR_MAPPING_AIRPORT: "/common/airport/city-pair-list",
  CALENDER_PRICING: "common/calendarPricing",
  CLAIM_STATUS_ROUTE_API: "flight/flight-status/by-route",
  FLIGHT_FARE_API: "/airaward-flights/get-fare",
  CMS_SOCIAL_PLATFORMS: "/content/dam/thaiairways/json/en-th/socialMedia.json",
  CRM_MANAGE_MILES: "/homepage/json/managemilesdata/jcr:content/root/responsivegrid/managemilesdata.model.json",
  CMS_NEWSANNOUNCEMENT: "/newsandannouncement.json",
  NEWSLETTER_PROMOTIONS_FROM_OPTIONS_API: "/custom_config/country-city-state/en/newsletterPreferenceList.json",
  PROFILE_CONTACT_UPDATE: "profile/user/update",
  FETCH_MAIN_MEMBER_PROFILE: "profile/getMainMemberProfile",
  FETCH_CRM_MEMBER_PROFILE: "mythai/profile",
  FETCH_MAIN_MEMBER_MILES: "loyalty/miles",
  FLIGHT_SCHEDULE: "flight-timetable",
  AIR_AWARD_BOOKING_API: "/airaward/booking",
  AIR_AWARD_PNR_API: "/airaward/pnr",
  AIR_AWARD_PRICE_API: "/airaward/price",
  AIR_AWARD_TST_API: "/airaward/tst",
  RETRIVE_PNR: "/airaward-review/pnr/review",
  CANCEL_BOOKING_PNR: "/airaward-review/booking/cancel",
  AIR_AWARD_REVIEW_PNR_API: "/airaward-review/pnr/rf",
  AIR_AWARD_REVIEW_PNR_RM_API: "/airaward-review/pnr/rm",
  AIR_AWARD_REVIEW_PNR_CANCEL_API: "/airaward-review/pnr/cancel",
  FETCH_MY_LIFESTYLE: "loyalty/lifestyle",
  CRM_FETCH_PROFILE: "mythai/profile",
  DELETE_TRIP_CARD: "/trip/delete",
  AIR_AWARD_AIRPORT_API: "/airaward-flights/airports",
  PROFILE_PERSONAL_INFO_UPDATE: "/profile/user/update",
  CRM_LOGIN: "mythai/login",
  CRM_LOGIN_VALIDATE: "mythai/login/validate",
  CRM_ENROLL: "mythai/v2/enrol",
  CRM_LOGIN_OTP: "mythai/login/otp/submit",
  SOCIAL_MEDIA_AUTH: "/mythai/social-media/auth",
  SOCIAL_MEDIA_SIGN_UP: "mythai/social-media/signup",
  FETCH_DATA_CONSTANT: "FETCH_DATA",
  CRM_PROFILE_UPDATE: "mythai/profile/update",
  MILEAGE_STATEMENT: "loyalty/miles/info",
  MILEAGE_AWARD_LIST: "loyalty/member-award/list",
  MILEAGE_AWARD_DETAIL: "loyalty/member-award/detail",
  MILEAGE_REPORT: "loyalty/miles/report",
  E_RECEIPT_API: "ereceipt/printEreceipt",
  UPDATE_SPONSOR_API: "ereceipt/updateSponsor",
  ROP_CHANGE_PASSWORD_API: "/profile/change-pin/otp",
  ROP_CHANGE_PASSWORD_OTP_RESEND_API: "/profile/change-pin/otp/resend",
  ROP_CHANGE_PASSWORD_SUBMIT_API: "/profile/change-pin/otp/submit",
  CRM_RESEND_OTP: "/mythai/login/otp/resend",
  CRM_LOGOUT: "mythai/logout",
  IOS_APP_QR: "/assets/app_download_qr/ios_app_download.png",
  ANDROID_APP_QR: "/assets/app_download_qr/android_app_download.png",
  AIR_AWARD_PAYMENT_INIT: "/airaward-review/payment",
  TEAMSITE_MY_TRIPS_UPCOMING_TRIPS_API: "/trip/retrieve-trips",
  MY_TRIPS_RETRIEVE_API: "/trip/retrieve-pnr",
  BACK_TRACKING_AIRPORT_API: "/airaward-flights/airports/backtracking",
  CRM_TEAMSITE_HELP_ENDPOINT: "/homepage/json/helpmenu/jcr:content/root/responsivegrid/helpmenu.model.json",
  ADD_MY_TRIP_API: "/trip/add",
  CRM_ERECEIPT_TERMS_CONDITION: "/homepage/json/ereceipt-termscondition/jcr:content/root/responsivegrid/ereceipt.model.json",
  CRM_NATIONALITY_API: "/custom_config/country-city-state/en/crmnationality.json",
  MY_TRIPS_CHECK_IN_API: "check-in/journeys",
  MY_TRIPS_CHECK_IN_CPR_API: "checkin/cpr",
  COUNTRY_DATA: "/custom_config/country-city-state/en/country-nationality-code-flag.json",
  CITY_DATA: "/custom_config/country-city-state/en/city_state_mapping.json",
  STATE_DATA: "/custom_config/country-city-state/en/state_country_mapping.json",
  CURRENCY_DATA: "/custom_config/country-city-state/currencies.json",
  PAID_NOMINEE_SEND_OTP: "loyalty/nominee/paidnominee/otp",
  PAID_NOMINEE_RESEND_OTP: "loyalty/nominee/paidnominee/resend-otp",
  PAID_NOMINEE_SUBMIT_OTP: "loyalty/nominee/paidnominee/submit-otp",
  FETCH_ELIGIBILITY: "loyalty/membertier/award/eligibility",
  CRM_TEAMSITE_MEMBER_STATUS_TERMS: "/homepage/json/memberstatuscalculator/jcr:content/root/responsivegrid/membercalculator.model.json",
  CRM_TEAMSITE_EXTEND_EXPIRY_MILES_TERMS_CONDITION: "/homepage/json/extendexpirymile/jcr:content/root/responsivegrid/extendexpirymile.model.json",
  CRM_COUNTRYCODE_JSON: "/custom_config/country-city-state/en/crmcountryphonecode.json",
  CRM_NEWSLETTERPREFERENCE_JSON: "/custom_config/country-city-state/en/newsletterPreferenceList.json",
  CRM_RESIDENCE_JSON: "/custom_config/country-city-state/en/crmresidence.json",
  MEMBER_TIER_CALCULATOR: "/loyalty/membertier/calculate",
  CRM_TEAMSITE_GIFT_MILES_TERMS_CONDITION: "/homepage/json/giftmilesterms/jcr:content/root/responsivegrid/giftmiles.model.json",
  FETCH_GIFT_MILES_DROPDOWN: "/loyalty/mileage-purchase/listMileage",
  CLAIM_MISSING_MILES_API: "/loyalty/retro-claim/star-alliance-missing-miles",
  CLAIM_MISSING_STAR_API: "/loyalty/retro-claim/tg-missing-miles",
  CRM_CLAIM_TERMS_CONDITION: "/homepage/json/claimmissing-termscondition/jcr:content/root/responsivegrid/claimmissing.model.json",
  // CLAIM_BOOKING_CLASS_API: "/claim-booking-classes.json",
  CLAIM_AIRLINE_API: "/common/airline/list",
  MEMBER_AWARD: "/loyalty/membertier/award/eligibility",
  MY_THAI_MY_REQUEST_API: "/mythai/my-requests",
  CRM_MILEAGE_PURCHASE_TERMS_CONDITION: "/homepage/json/mileagepurchaseterms/jcr:content/root/responsivegrid/mileagepurchase.model.json",
  REVIEW_SUMMARY_GIFT_MILES: "/loyalty/miles/gift/review",
  PROCESS_PAYMENT_GIFT_MILES: "/loyalty/mileage-purchase/processPayment",
  GIFT_MILES_DOWNLOAD_RECEIPT: "/loyalty/mileage-purchase/paymentReceipt",
  CRM_TEAMSITE_TRANSFER_MILES_TERMS_CONDITION: "/homepage/json/transfermiles-terms/jcr:content/root/responsivegrid/transfermiles.model.json",
  TRANSFER_MILES_REVIEW: "/loyalty/miles/transfer/review",
  TRANSFER_MILES_PAYMENT_INIT: "/loyalty/miles/transfer/payment-init",
  TRANSFER_MILES_DOWNLOAD_RECEIPT: "loyalty/miles/transfer/receipt",
  EXTEND_MILES_PAYMENT_INIT: "/loyalty/miles/extend/paymentInit",
  EXTEND_MILES_DOWNLOAD_RECEIPT: "/loyalty/miles/extend/paymentReceipt",
  EARNED_MILES_API: "/loyalty/miles-calculator/earned-miles",
  REDEEM_MILES_API: "/loyalty/miles-calculator/redeem-miles",
  STAR_ALLIANCE_AIR_LINE_LIST_API: "/common/airline/list",
  EXCESS_BAGGAGE_API: "/loyalty/miles-calculator/excess-baggage-awards",
  UPGRADE_SEAT_API: "/loyalty/miles-calculator/upgrade-seat-awards",
  BAGGAGE_ALLOWANCE: "common/more-services/excess-baggage-info",
  SEAT_PREFERENCE: "common/more-services/preferred-seat",
  BARCODE_SCANNING: "common/barcode/retrieve",
  BAGGAGE_SEARCH: "loyalty/baggage/bagJourney",
  MILES_SEARCH: "loyalty/miles-calculator/air-awards-miles",
  VIEW_MICE_OFFERS: "adminportal/mice/event-validate",
  EVENTS_LIST: "adminportal/mice/manage-info",
  SUBMIT_EVENT: "adminportal/mice/proposal-form",
  VERIFY_BOOKING: "loyalty/upgrade-seat/verify-booking",
  UPGRADE_FLIGHT: "loyalty/upgrade-seat/review",
  REACT_APP_CREDIT_CARD_PARTNERS: "homepage/earn-miles/credit-card-partners.html",
  REACT_APP_STAR_ALLIANCE: "https://www.staralliance.com/en/members",
  //STAR ALLIANCE REDEMPTION
  STAR_ALLIANCE_AIRPORT_LIST: "/airaward-flights/star-airports/route?multiCity=false",
  STAR_ALLIANCE_AIRPORT_LIST_MULTI_CITY: "/airaward-flights/star-airports/route?multiCity=true",
  STAR_ALLIANCE_SEARCH: "airaward-flights/star-get-flight-info",
  DOWNLOAD_AIRPORT_BOOKING_PDF: "airaward-review/report/payment-summary",
  CRM_CHANGE_PASSWORD: "/mythai/profile/changePassword/otp",
  CRM_CHANGE_PASSWORD_OTP_RESEND: "/mythai/profile/changePassword/otp/resend",
  CRM_CHANGE_PASSWORD_SUBMIT: "/mythai/profile/changePassword/otp/submit",
  MILES_BEYOND_BANGKOK: "pdf/Star_Alliance_Awards_Chart_2019-One_way.pdf",
  POWER_OF_ATTORNEY: "pdf/flight-disruption/POWER_OF_ATTORNEY.pdf",
  UMNR_FORM: "pdf/service-request/UMNR_Form.pdf",
  MEDIF_FORM: "pdf/service-request/MEDIF-FORM-2018.pdf",
  HELP_FAQ: "/mythai/feedback",
  REACT_APP_ADDITIONAL_BAGGAGE: "/more-services/online-excess-baggage",
  REACT_APP_PREFERRED_SEATS: "/more-services/preferred-Seats",
  REACT_APP_PREFERRED_MEALS: "/more-services/pre-select-meals",
  REACT_APP_ELIBRARY: "/in-flight-experience/e-library",
  REACT_APP_ROP_MAIL: "mailto:ropsvc@thaiairways.com",
  REACT_APP_ERECEIPT_CONTACT_MAIL: "mailto:digital-accounting@thaiairways.com",
  REACT_APP_STORE_URL: "https://apps.apple.com/us/app/thai-airways/id1393912966",
  REACT_PLAY_STORE_URL: "https://play.google.com/store/apps/details?id=com.thaiairways.mobile",
  REACT_HUAWEI_STORE_URL: "https://appgallery.huawei.com/app/C101200261",
  REACT_APP_SILVER_BENEFITS_URL: "https://www.thaiairways.com/en_TH/rop/Status_Benefits/BenefitStatus-02-silver.page?",
  REACT_APP_GOLD_BENEFITS_URL: "https://www.thaiairways.com/en_TH/rop/Status_Benefits/BenefitStatus-03-gold.page?",
  REACT_APP_PLATINUM_BENEFITS_URL: "https://www.thaiairways.com/en_TH/rop/Status_Benefits/BenefitStatus-04-platinum.page?",
  REACT_APP_STAUS_BENEFITS_URL: "https://www.thaiairways.com/en_TH/rop/Status_Benefits/BenefitStatus-01.page?",
  S3_REDEMPTION_LOGO_URL: "/images/airaward/logos/airlines/",
  REACT_APP_UPGRADE_SEATS_STAR_ALLAIANCE_URL: "https://www.thaiairways.com/en_TH/rop/Redeeming/Redeeming_Award_UpgradeAwards_onStarAlliance.page?",
  PRESELECT_MEAL: "/ancillaries/preselect-meal/retrieve",
  MEALS_LIST: "/ancillaries/preselect-meal/meal-list",
  Travel_Class_API: "/flight/flight-schedule",
  PRESELECT_SUBMIT_MEAL: "/ancillaries/preselect-meal/update",
  // TEAMSITE_PRESELECT_TERMS: "/preselectTermsConditions.json",
  ROP_SIGNUP_API_URL: "profile/enroll/add-rop-member",
  ROP_OTP_URL: "/loyalty/otp/generate",
  REDIRECTIONURL: "https://sawasdee.thaiairways.com/",
  SWASDEEPOCKETGUIDEURL: "https://sawasdee.thaiairways.com/pocket-guides/",
  FLIGHT_SCHEDULE_URL: "/flight/flight-schedule",
  FLIGHT_UPGRADE_SEAT: "loyalty/upgrade-seat/submit",
  SETTINGS_JSON: "json/settings.json",
  REACT_APP_OSCI_TG_AEM_JSON_BASE_URL: "content/dam/osci/",
  // DAPI BOOKING
  DAPI_BOOKING_MARKET_ROLLOUT_JSON: "json/marketWiseRolloutPlan.json",
  DAPI_BOOKING_CONTENT_AEM: "content/dapibooking",
  REACT_APP_DAPI_BOOKING_TG_AEM_JSON_BASE_URL: "content/dam/dapi-booking/",
  DAPI_BOOKING_SHOPPING_CART: "common/shopping-cart/list",
  // DAPI
  ADD_PAX_CHECK_IN_API: "/check-in/passengers/merge",
  DAPI_CANCEL_CHECKIN: "/check-in/cancel",
  AIR_AWARD_CONFIRMATION: "/airaward-review/pnr/confirmation/summary",
  DAPI_CANCEL_RETRIEV_CHECKIN: "check-in/journey",
  REMOVE_SELECT_PASSENGER_CHECKIN: "/check-in/passengers",
  SELECT_PASSENGER_REGULATORY_CHECKIN: "/check-in/passengers/regulatory-details",
  SELECT_PASSENGER_DATA_CHECKIN: "/check-in/passengerData",
  UPDATE_PASSENGER_DETAILS: "/check-in/passengers/regulatory-details/upsert",
  FLIGHT_STATUS_NUMBER: "flight/flight-status/by-number",
  PASSENGER_DETAILS_FFP: "/custom_config/frequent_flyer_program/frequent_flyer_pgmlist.json",
  DAPI_PASSENGER_DETAILS_NATIONALITY: "/homepage/json/nationalitycode/jcr:content/root/responsivegrid/nationalitycode.model.json",
  CHECKIN_PASSENGER_DETAILS_JSON: "/homepage/json/regulatoryconfig/jcr:content/root/responsivegrid/regulatoryconfig.model.json",
  CHECKIN_BP_SAVE_PDF: "/check-in/boarding-passes/pdf",
  EXPIRING_MILES_REVIEW: "/loyalty/miles/extendExpiringMiles/review",
  MYTHAI_CRM_FORM_FLIGTH_SUPPORT: "/mythai/flight-support",
  MYTHAI_ROP_FORM_FLIGTH_SUPPORT: "/mythai/rop-services",
  CHECKIN_AUTO_SEAT_SELECTION: "/ancillaries/checkin/seat",
  SEAT_MAP_CHECK_IN_API: "/ancillaries/checkin/seatmap",
  CRM_SERVICE_REQUEST: "mythai/special-service-request",
  MYTHAI_CRM_LOST_FOUND: "mythai/special-request/item-loss",
  FlIGHT_DISRUPTION_CERT: "mythai/flight-disruption-certificate",
  BAGGAGE_CLAIM: "mythai/special-request/property-claim",
  CHECKIN_SEND_OTP: "/check-in/otp",
  CHECKIN_RESEND_OTP: "/check-in/resend-otp",
  CHECKIN_ADD_FFP: "/check-in/addffp",
  CHARTER_FLIGTH_FORM_API: "/common/charter-flight",
  COMPLETE_CHECKIN: "/check-in/acceptance",
  FFP_PROGRAM_LIST: "/homepage/json/frequentflyerprogram/jcr:content/root/responsivegrid/frequentflyer.model.json",
  CMS_DANGEROUS_GOODS_API: "/homepage/json/dangerous-goods/jcr:content/root/container/container/dangerous_goods.model.json",
  MICE_BOOKING_API: "miceBooking",
  PROMO_CODE_INFO: "adminportal/promo/info",
  CRM_EARNEDMILESTERMS_TERMS_CONDITION: "homepage/json/earnedmilesterms/jcr:content/root/responsivegrid/earnedmilesterms.model.json",
  CRM_GET_MY_THAI: "/homepage/json/mythaicrm/jcr:content/root/responsivegrid/mythaicrm.model.json",
  CRM_REDEEM_MILES_CLASSES: "homepage/json/redeemmilesclasses/jcr:content/root/responsivegrid/redeemmilesclasses.model.json",
  AEM_SUB_DIRECTORY: "/content",
  STAR_ALLIANCE_REDIRECTION_URL: "https://www.staralliance.com/en/",
  POPULAR_FARE: "/common/calendarPricing/popular-fares",
  CRM_DIRECT_FLIGHT_AWARDS: "/homepage/json/directflightawards/jcr:content/root/responsivegrid/directflightawards.model.json",
  CRM_GET_EXCESS_BAGGAGE_URL: "/homepage/json/excess-baggage/jcr:content/root/responsivegrid/excess_baggage.model.json",
  CRM_GET_UPGRADE_SEAT_URL: "/homepage/json/upgradeseat/jcr:content/root/responsivegrid/upgradeseat.model.json",
  CRM_GET_ERECEIPT_HOW_TO_GO_URL: "/homepage/json/ereceipt-howtoget/jcr:content/root/responsivegrid/getereceipt.model.json",
  CRM_TEAMSITE_BAGGAGE_ALLOWANCE: "/content/dam/thaiairways/json/common/baggageAllowanceOSCI.json",
  ADDITIONAL_SERVICES: "/content/dam/thaiairways/json/common/additional-booking-services.json",
  //REACT_AIRCRAFT_URL: "content/thaiairways/",

  REACT_AIRCRAFT: "/homepage/our-aircraft",
  REACT_INFIGHT_EXP: "/homepage/in-flight-experience.html",
  PROMOCODE_API: "promocode/booking",
  GOLD_TRACK: "common/airport/list/by_filter",
  GOLT_TRACK_INFORMATION: "common/more-services/goldTrack",
  LOUNGE_FINDER: "common/more-services/loungeFinder",
  LOUNGE_AMENITY: "content/dam/thaiairways/images/ground-services/lounge/amenity-icons/",
  AIRPORT_INFORMATION_URL: "/homepage/airport-information.html",
  CRM_MyPERSONAL_API: "/homepage/json/travelclassjson/jcr:content/root/responsivegrid/travelclassjson.model.json",
  INFLIGHT_IMAGE: "/content/dam/thaiairways/images/travel-class/travelexperience/in-flight-service.png",
  THAI_LOUNGES_IMAGE: "/content/dam/thaiairways/images/travel-class/travelexperience/thai-lounges.png",
  THAI_LOUNGES_IMAGEONE: "/content/dam/thaiairways/images/travel-class/travelexperience/thai-lounges-card.png",
  CRM_TERMSANDCONDISTION_CRM: "/homepage/json/termsandconditionscrm/jcr:content/root/responsivegrid/termsandconditionscr.model.json",
  CRM_FOOD: "content/dam/thaiairways/json/common/food.json",
  CRM_HOBBIES_AND_INTERESTS: "content/dam/thaiairways/json/common/hobbiesAndInterests.json",
  CRM_MAGAZINE: "content/dam/thaiairways/json/common/magazine.json",
  CRM_SPORTS: "content/dam/thaiairways/json/common/sports.json",
  CRM_NEWSPAPER: "content/dam/thaiairways/json/common/newspapers.json",
  CRM_TRAVEL: "content/dam/thaiairways/json/common/travel.json",
  CRM_TICKET_RESTRICTION: "/homepage/json/ticketrestriction/jcr:content/root/responsivegrid/ticketrestriction.model.json",
  PROMO_CODE_TERMS: "/homepage/json/promocodejson/jcr:content/root/responsivegrid/promocodejson.model.json",
  SAWASDHEE_INFORMATION: "common/feeds",
  TOKEN_EXPIRED: "/profile/user/refreshToken",
  CRM_MEAL: "content/dam/thaiairways/json/common/en-th/meal.json",
  CRM_TERM_CONDITIONS_PROFILE_COMPONENTS: "/homepage/json/termconditionsprofile/jcr:content/root/responsivegrid/termconditionsprofil.model.json",
  CRM_TEAMSITE_PRESELECT_TERMS: "/homepage/json/preselecttermsconditions/jcr:content/root/responsivegrid/preselecttermscondit.model.json",
  CRM_PRIVILEGE: "homepage/json/privilege/jcr:content/root/responsivegrid/privilege.model.json",
  CRM_SUBSCRIBE: "homepage/json/preferencetermsconditions/jcr:content/root/responsivegrid/preferencetermscondi.model.json",
  CRM_BOOKFLIGHT: "homepage/json/bookflightservices/jcr:content/root/responsivegrid/bookflightservices.model.json",
  CRM_REDEMPTION_PARTNER_CARD: "homepage/json/redemptionpartnercard/jcr:content/root/responsivegrid/redemptionpartnercar.model.json",
  CRM_TNCREVIEW_INFO: "homepage/json/tncreviewinfo/jcr:content/root/responsivegrid/tncreviewinfo.model.json",
  CRM_PRESELECTMEALS: "homepage/json/preselectmealwidgetdata/jcr:content/root/responsivegrid/preselectmealwidgetd.model.json",
  CRM_EARM_MILES: "homepage/json/claimbookingclasses/jcr:content/root/responsivegrid/claimbookingclasses.model.json",
  CRM_MY_THAI_CRM: "homepage/json/mythaicrm/jcr:content/root/responsivegrid/mythaicrm.model.json",
  CRM_LOUNGE_GOLD_TRACK: "homepage/json/loungeandgoldtrack/jcr:content/root/responsivegrid/loungegoldtrack.model.json",
  AUS_ABF_URL: "https://www.abf.gov.au/entering-and-leaving-australia/can-you-bring-it-in/categories/duty-free",
  AUS_MMB_URL: "https://immi.homeaffairs.gov.au/change-in-situation/passport-details",
  DESTINATION_IMG: "images/destination-banners/",
  STATUS_BENEFITS: "content/status-and-benefits",
  CRM_REVIEWINFOTERMSCONDITION: "homepage/json/reviewinfotermscondition/jcr:content/root/responsivegrid/reviewinfotermscondi.model.json",
  BAGGAGE_DAMAGE_CLAIM: "/loyalty/baggage/baggage-damage-claim-form",
  COMPENSATION_REQUEST: "/loyalty/compensation/compensation-claim-form",
  REFUNDAIRFAREFEE_REQUEST: "/mythai/flight-disruption-refund",
  FD_COMPENSATION_REQUEST: "/mythai/flight-disruption-compensation",
  GOVERNMENT_BOOKING_SIGNIN: "/adminportal/auth/signin",
  GOVERNMENT_BOOKING_API: "government/booking",
  GOVERNMENT_BOOKING_MULTI_CITY_API: "government/multi/booking",
  GOVERNMENT_BOOKING_LIFE_STYLE: "homepage/json/government-booking/lifestyle/jcr:content/root/responsivegrid/lifestyle.model.json",
  GOVERNMENT_BOOKING_PLAN_MY_TRIP: "/homepage/json/government-booking/plan-my-trip/jcr:content/root/responsivegrid/lifestyle.model.json",
  GOVERNMENT_BOOKING_MORE_SERVICE: "/homepage/json/government-booking/more-services/jcr:content/root/responsivegrid/moreservices.model.json",
  CRM_GOVERNMENT_BOOKING_NEWS_ANNOUNCEMENT: "/homepage/json/government-booking/news-announcement/jcr:content/root/responsivegrid/newsandannouncementh.model.json",
  CRM_GOVERNMENT_BOOKING_FAQ: "/homepage/json/government-booking/faqs/jcr:content/root/responsivegrid/faqjson.model.json",
  CORPORATE_COMPLEMENT_JOURNEY: "/homepage/json/complementjourney/jcr:content/root/responsivegrid/complementjourney.model.json",
  CORPORATE_NEW_ANNOUNCEMENTS: "/homepage/json/corporate/newscorporate/jcr:content/root/container/container/newscorporateandagency.model.json",
  AGENCY_NEW_ANNOUNCEMENTS: "/homepage/json/agency/newsagency/jcr:content/root/container/container/newscorporateandagency.model.json",
  UNLOCK_ACCOUNT_CORPORATE_API: "adminportal/corporateUser/reset-password",
  CORPORATE_BOOKING_SIGNIN: "/adminportal/auth/signin",
  DAPI_COUNTRY_LIST_JSON: "/homepage/json/countrycode/jcr:content/root/responsivegrid/countrycode.model.json",
  DAPI_CHECKIN_ERROR_CODES_JSON: "/homepage/error-page/jcr:content/root/container/container/error_message.model.json",
  DAPI_CHECKIN_FLIGHT_LAYOUT_JSON: "/homepage/json/aircraft/b777-300er/77y/jcr:content/root/responsivegrid/aircraftimgjson.model.json",
  DAPI_CHECKIN_SEAT_CHARACTERISTICS_JSON: "/homepage/json/seatmap-characteristics/jcr:content/root/container/container/seatmap.model.json",
  DAPI_PASSPORT_VALIDITY_COUNTRIES_JSON: "/homepage/json/passportvaliditycheck/jcr:content/root/responsivegrid/passportvalidity.model.json",
  DAPI_CHECKIN_AIRCRAFT_LAYOUT_1: "/homepage/json/aircraft/",
  DAPI_CHECKIN_AIRCRAFT_LAYOUT_2: "/jcr:content/root/responsivegrid/aircraftimgjson.model.json",
  CORPORATE_BOOKING_SIGNUP: "/adminportal/corporate/submit-request",
  MY_SAMSUNG_WALLET_API: "check-in/wallet/samsung/link",
  AIRPORT_ROUTE_WISE: "/homepage/json/airport-configuration/jcr:content/root/responsivegrid/airportroutedetails.model.json",
  DAPI_CHECKIN_BP_SEND_EMAIL: "check-in/boarding-passes/email",
  CORPORATE_CATEGORY_LIST: "mdm/corporate-agent-categories",
  DAPI_CHECKIN_DESTINATION_BANNER: "/homepage/json/destinationbanner/jcr:content/root/responsivegrid/destinationbannerjso.model.json",
  S3_DAPI_LOGO_URL: "/images/airaward/logos/airlines/mobile",
  DAPI_EXIT_ROW_QUESTIONNAIRE: "/homepage/json/exit-row/_jcr_content/root/responsivegrid/exitrowjson.model.json",
  DAPI_JOIN_NOW: "/homepage/json/join-now/jcr:content/root/responsivegrid/joinnow.model.json",
  DAPI_UPDATE_EXIT_ROW: "check-in/updateExitSeat",
  FLIGHT_UPGRADE_SPEND_MILES: "/homepage/spend-miles/jcr:content/root/responsivegrid/moreservice.model.json",
  DAPI_SEAT_MAP_AIRCRAFT: "/json/AircraftJson.json",
  DAPI_AIRLINES_JSON: "/json/AirlinesNames.json",
  DAPI_MARKET_ROLLOUT_JSON: "json/marketRollOut.json",
  POPULARFARE_REQUESTED_AIRPORTS: "custom_config/common/web-everymundo-filter-dropdown.json",
  DAPI_INSURANCE_QUOTATION_API: "ancillaries/insurance/quotation",
  DAPI_INSURANCE_PURCHASE_API: "ancillaries/insurance/purchase",
  REACT_APP_DAPI_TG_AEM_BASE_URL: "content/dapicheckin/",
  REACT_APP_DAPI_TG_DESKTOP_BANNER_URL: "content/dam/dapicheckin/destination_banners/desktop_images/",
  REACT_APP_DAPI_TG_MOBILE_BANNER_URL: "content/dam/dapicheckin/destination_banners/mobile_images/",
  REACT_APP_DAPI_TG_AEM_JSON_BASE_URL: "content/dam/dapicheckin/",
  REACT_APP_DAPI_TG_LOCALLABEL_BASE_URL: "/homepage/json/local-label-translation/jcr:content/root/responsivegrid/locallabels.model.json",
  DAPI_INSURANCE_PAYMENT_API: "/order/payment/init",
  DAPI_INSURANCE_PAYMENT_STATUS_API: "/order/payment/status",
  DAPI_INSURANCE_PAYMENT_FINALIZE_API: "/ticketing/checkin/finalize",
  DAPI_CONFIG_URL: "json/dynamicConfigDapiCheckin.json",
  DAPI_CHECKIN_AGREEMENT_JSON: "homepage/json/non-tg-airlines/jcr:content/root/responsivegrid/nontgairlines.model.json",
  ORDER_RETRIEVE: "order/retrieve-booking",
  DAPI_ORDER_INSURANCE_RETRIEVE: "/order/retrieve",
  DAPI_DANGEROUS_GOODS: "/homepage/dangerous-goods-webpage.html",
  REACT_DAPI_INSURANCE_JSON: "content/dapibooking/",
  REACT_DAPI_INSURANCE_MODEL: "/homepage/json/insurance/",
  REACT_DAPI_INSURANCE_MODEL_END_URL: "jcr:content/root/responsivegrid/insurance.model.json",
  TRIP_WEATHER_INFO: "/common/weather-info/",
  DAPI_CHECKIN_PAYMENT_TNC: "homepage/json/payment-terms-and-conditions/jcr:content/root/responsivegrid/termconditionsprofil.model.json",
  DAPI_AIRPORT_CODE_JSON: "/json/AirportCode.json",
  DAPI_CITY_CODE_JSON: "/json/CityCode.json",
  DAPI_EARN_MILES_URL: "/loyalty/miles-calculator/trip-earned-miles",
  DAPI_CHECKIN_ANCILLARIES_JSON: "/json/Ancillaries.json",
  COMMON_CACHE_FILTERED_COOKIE: "/common/cache/filtered-cookie",
  //DAPI MMB
  DAPI_MMB_MARKET_ROLLOUT_JSON: "json/marketRollOut.json",
  REACT_APP_DAPI_MMB_TG_AEM_JSON_BASE_URL: "content/dam/mmb/",
  DAPI_MMB_ERROR_JSON: "content/dam/dapi-booking/json/ErrorCode.json",
  CORPORATE_BOOKING_API: "corporateAgentBooking",
  DAPI_BOOKING_CONFIG: "/homepage/json/booking-flight-listing-config/jcr:content/root/responsivegrid/flightlisting.model.json",
  CORPORATE_AGENCY_TOKEN_EXPIRED: "/adminportal/auth/refresh",
  ROP_ENABLE_JSON: "/homepage/json/rop-enablement-maintenance-json/jcr:content/root/responsivegrid/ropenablement.model.json",
  ROP_TRANSLATION_JSON: "/homepage/json/rop-local-labels-translations/jcr:content/root/responsivegrid/locallabels.model.json",
  ROP_TG_AEM_BASE_URL: "content/thaiairways/",
  UNLOCK_ACCOUNT__NEW_API: "profile/user/v1/resetPinSubmit",
  RESET_PASSWORD_AFTER_EMAIL_VERFICATION: "profile/user/email-verify/reset-password",
  UNLOCK_ACCOUNT_SUBMIT_API: "profile/user/v1/unlockAccountSubmit",
  ROP_FETCH_PROFILE: "profile/v1/fetchProfile",
  ROP_FETCH_NIOMINEE: "/loyalty/v1/nominee",
  ROP_PROFILE_CONTACT_UPDATE: "profile/user/v1/update",
  ROP_FETCH_MAIN_MEMBER_PROFILE: "profile/v1/getMainMemberProfile",
  ROP_FETCH_MAIN_MEMBER_MILES: "loyalty/v1/miles",
  ROP_AIR_AWARD_BOOKING_API: "/airaward/v1/booking",
  ROP_AIR_AWARD_PRICE_API: "/airaward/v1/price",
  ROP_FETCH_MY_LIFESTYLE: "loyalty/v1/lifestyle",
  ROP_PROFILE_PERSONAL_INFO_UPDATE: "/profile/user/v1/update",
  ROP_MILEAGE_STATEMENT: "loyalty/v1/miles/info",
  ROP_MILEAGE_AWARD_LIST: "loyalty/member-award/v1/list",
  ROP_MILEAGE_AWARD_DETAIL: "loyalty/member-award/v1/detail",
  ROP_MILEAGE_REPORT: "loyalty/v1/miles/report",
  ROPP_CHANGE_PASSWORD_API: "/profile/v1/change-pin/otp",
  ROPP_CHANGE_PASSWORD_OTP_RESEND_API: "/profile/v1/change-pin/otp/resend",
  ROPP_CHANGE_PASSWORD_SUBMIT_API: "/profile/v1/change-pin/otp/submit",
  ROP_COUNTRY_ROP_DATA: "/mdm/v1/location/countries",
  ROP_STATE_ROP_DATA: "/mdm/v1/location/states",
  ROP_CITY_ROP_CODE: "mdm/v1/location/cities",
  ROP_PAID_NOMINEE_SEND_OTP: "loyalty/v1/nominee/paidnominee/otp",
  ROP_PAID_NOMINEE_RESEND_OTP: "loyalty/v1/nominee/paidnominee/resend-otp",
  ROP_PAID_NOMINEE_SUBMIT_OTP: "loyalty/v1/nominee/paidnominee/submit-otp",
  ROP_FETCH_ELIGIBILITY: "loyalty/membertier/award/v1/eligibility",
  ROP_MEMBER_TIER_CALCULATOR: "/loyalty/membertier/v1/calculate",
  ROP_CLAIM_MISSING_MILES_API: "/loyalty/retro-claim/v1/star-alliance-missing-miles",
  ROP_CLAIM_MISSING_STAR_API: "/loyalty/retro-claim/v1/tg-missing-miles",
  ROP_MEMBER_AWARD: "/loyalty/membertier/award/v1/eligibility",
  ROP_REVIEW_SUMMARY_GIFT_MILES: "/loyalty/miles/gift/v1/review",
  ROP_PROCESS_PAYMENT_GIFT_MILES: "/loyalty/mileage-purchase/v1/processPayment",
  ROP_GIFT_MILES_DOWNLOAD_RECEIPT: "/loyalty/mileage-purchase/v1/paymentReceipt",
  ROP_TRANSFER_MILES_REVIEW: "/loyalty/miles/transfer/v1/review",
  ROP_TRANSFER_MILES_PAYMENT_INIT: "/loyalty/miles/transfer/v1/payment-init",
  ROP_TRANSFER_MILES_DOWNLOAD_RECEIPT: "loyalty/miles/transfer/v1/receipt",
  ROP_EXTEND_MILES_PAYMENT_INIT: "/loyalty/miles/extend/v1/paymentInit",
  ROP_EXTEND_MILES_DOWNLOAD_RECEIPT: "/loyalty/miles/extend/v1/paymentReceipt",
  ROP_EARNED_MILES_API: "/loyalty/miles-calculator/v1/earned-miles",
  ROP_REDEEM_MILES_API: "/loyalty/miles-calculator/v1/redeem-miles",
  ROP_UPGRADE_SEAT_API: "/loyalty/miles-calculator/v1/upgrade-seat-awards",
  ROP_UPGRADE_FLIGHT: "loyalty/upgrade-seat/v1/review",
  ROP_SIGNUP_API_NEW_URL: "profile/enroll/v1/add-rop-member",
  ROPP_OTP_URL: "/loyalty/otp/v1/generate",
  ROP_FLIGHT_UPGRADE_SEAT: "loyalty/upgrade-seat/v1/submit",
  ROP_EXPIRING_MILES_REVIEW: "/loyalty/miles/extendExpiringMiles/v1/review",
  ROP_CHECKIN_SEND_OTP: "/check-in/v1/otp",
  ROP_CHECKIN_RESEND_OTP: "/check-in/v1/resend-otp",
  ROP_CHECKIN_ADD_FFP: "/check-in/v1/addffp",
  ROP_DAPI_INSURANCE_PAYMENT_API: "/order/payment/v1/init",
  ROP_DAPI_INSURANCE_PAYMENT_STATUS_API: "/order/payment/v1/status",
  ROP_DAPI_EARN_MILES_URL: "/loyalty/miles-calculator/v1/trip-earned-miles",
  ROP_FORGOT_MEMBER_ID: "profile/user/v1/forgotMemberId",
  EMAIL_VERFICATION_ENROLL: "profile/user/email-verify/enrol",
  REACT_APP_OSCI_LOCALLABELS_BASE_URL: "/homepage/json/osci-local-labels-translations/jcr:content/root/responsivegrid/locallabels.model.json"
};